import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import appInfo from "@common/appInfo";
import { save } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";
import { type NetworkPlacement } from "./types";

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      error: localState.error,

      placementSettingOptions: localState.placementSettingOptions,
      settings: localState.settings,
      status: localState.status,
      userId: appInfo.user?.id ?? null
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  save: (settings: NetworkPlacement.SettingSettings[]) => dispatch(save({ ...getEntityRef(props), settings }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
